import { Link, useParams } from "react-router-dom"
import { API_URL, URLS } from "../../_config"
import { APP_CURRENCY_CODE, APP_NAME, LOGO_URL } from "../../_config/site_urls"
import Icon from "../../components/icon"
import { useToken, useUser } from "../../_common/hooks/authHook"
import { replaceUrlParams } from "../../_common/functions"
import React, { useEffect, useState } from "react"
import toast from "react-hot-toast"
import PayPalButton from "./PayPalButton"
import './PaymentDetails.scss'

const PaymentDetails = () => {
    let userData: any = useUser();
    const tokenData: any = useToken();
    const { proposalId } = useParams<{ proposalId: string }>();
    const [priceDetails, setPriceDetails] = useState<any>(null)
    const [proposalPrice, setProposalPrice] = useState<any>(null)
    const [totalAmount, setTotalAmount] = useState<any>(0)  
    const [payAmount, setPayAmount] = useState<any>(0) // Pay by user
    const [couponCode, setSouponCode] = useState<any>(null)
    const [couponCodeSubmit, setSouponCodeSubmit] = useState<any>(false)
    const [couponDiscount, setCouponDiscount] = useState<any>(0)
    const [currency, setCurrency] = useState<any>(APP_CURRENCY_CODE)
    const [vatAmount, setVatAmount] = useState<any>(0)
    const [discountAmount, setDiscountAmount] = useState<any>(0);
    const [adminDiscountDollar, setAdminDiscountDollar] = useState<any>(0);

    const getPriceDetails = async () => {
        try {
            const response = await fetch(replaceUrlParams(API_URL.ACCOUNT.MY_BUSINESS_PLAN_PRICE_DETAILS, { proposalId: proposalId }));
            const resp = await response.json();
            setPriceDetails(resp.data)
            // setProposalPrice(resp.data?.total_price_with_tax_vat_amount)
            setTotalAmount(resp.data?.total_price)
            setPayAmount(resp.data?.final_price_with_vat ? resp.data?.final_price_with_vat : resp.data?.total_price_with_tax_vat_amount)
            setCurrency(resp.data?.currency.toUpperCase())
            setVatAmount(resp.data?.tax_vat_amount)
            const safeNum = (val: unknown): number => { const n = Number(val); return isNaN(n) ? 0 : n; };
            const couponDiscount = safeNum(resp?.data?.discount);
            const adminDiscount  = resp?.data?.client_discount_type != 0 ? Math.max(0, safeNum(resp?.data?.amount) + safeNum(resp?.data?.total_addon_price) - safeNum(resp?.data?.final_price_before_vat)) : 0;
            setDiscountAmount(couponDiscount + adminDiscount);
            setAdminDiscountDollar(adminDiscount);
        } catch (error) {
            console.log('Error occurred while making the API request.');
            // Handle error
            setPriceDetails([])
        }
    }

    const applyCouponCode = () => {
        return new Promise((resolve, reject) => {
            fetch(API_URL.PAYMENTS.APPLY_COUPON_CODE, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${tokenData}` },
                body: JSON.stringify({ proposal_id: proposalId, coupon_code: couponCode }),
            })
                .then(response => response.json())
                .then(resp => {
                    if (resp?.status == 200) { // Success  
                        resolve(resp.message);
                        setSouponCodeSubmit(true)
                        setTotalAmount(resp?.data.after_discount_price);
                        setPayAmount(resp?.data.payble_amount);
                        setCouponDiscount(resp?.data.cupon_amount);
                        setVatAmount(resp?.data.vat_amount);
                    } else {
                        reject(resp.message);
                    }
                })
                .catch(error => {
                    reject(error.message);
                });
        })
    }


    const applyCouponCodeHandler = async () => {
        toast.promise(
            applyCouponCode(), {
            loading: 'Applying coupon code...',
            success: (msg: any) => {
                return <b>{msg}</b>
            },
            error: (msg: any) => { return <b>{msg}</b> },
        });
    }

    useEffect(() => {
        getPriceDetails()
    }, [])

    return (
        <>
            <div className="login-bg"></div>

            <div className="payment-box">
                <div className="payment-left-box">
                    <div className="d-flex align-items-center gap-2 w-100  mb-20 ">
                        <Link to={URLS.ACCOUNT.MY_BUSINESS_PLAN} ><Icon name="arrow-left-solid" size={28} /></Link>
                        <div className="env-box w-100">
                            <span><i className='bx bx-envelope'></i> {userData?.email}</span>
                            <i className='bx bxs-check-circle'></i>
                        </div>
                    </div>
                    <table className="table">
                        <tbody>
                            <tr className="bb-1">
                                <td colSpan={2}>
                                    <h4><Icon name="business-card" /> {priceDetails?.subsciption_plan?.subscription_plan_type?.title}</h4>
                                    {/* <h5><Icon name="business-card" /> {priceDetails?.subsciption_plan?.title}</h5> */}
                                </td>
                            </tr>

                            {
                                priceDetails && <div className="summery-table mt-2">
                                    <h3><Icon name="money-bill" /> Price Summary</h3>
                                    <table className="table">
                                        <tbody>
                                            {
                                                priceDetails?.subsciption_plan && <tr className="bb-1">
                                                    <td>
                                                        <span className="table-body-txt">{priceDetails?.subsciption_plan?.title}</span>
                                                    </td>
                                                    <td className="text-end">
                                                        <span className="table-body-txt"> {priceDetails?.plan_price > 0 ? priceDetails?.plan_price : '0.00'} {currency}</span>
                                                    </td>
                                                </tr>
                                            }
                                            {
                                                priceDetails?.addon?.length > 0 &&
                                                priceDetails?.addon?.map((addonData: any) => {
                                                    return <tr className="bb-1" key={`AddonsEle${addonData?.title}`}>
                                                        <td>
                                                            <span className="table-body-txt">{addonData?.title}</span>
                                                            <h5>Addons</h5>
                                                        </td>
                                                        <td className="text-end">
                                                            <span className="table-body-txt">{addonData?.price > 0 ? addonData?.price : '0.00'} {currency}</span>
                                                        </td>
                                                    </tr>
                                                })
                                            }


                                            {
                                                couponDiscount > 0 && <tr className="bb-1">
                                                    <td><span className="table-body-txt"> Coupon Discount </span></td>
                                                    <td className="text-end"><span className="table-body-txt">{couponDiscount} {currency}</span></td>
                                                </tr>
                                            }

                                            <tr className="bb-1">
                                                <td>
                                                    <span className="table-body-txt">
                                                        <b>
                                                            {priceDetails?.client_discount_type == 2
                                                                ? `Discount (${parseFloat(priceDetails?.client_discount_amount).toFixed(2)}%)`
                                                                : 'Discount (Fixed)'}
                                                        </b>
                                                    </span>
                                                </td>
                                                <td className="text-end">
                                                    <span className="table-body-txt">
                                                        {parseFloat(adminDiscountDollar).toFixed(2)} {currency}
                                                    </span>
                                                </td>
                                            </tr>

                                            <tr className="bb-1">
                                                <td><span className="table-body-txt"><b>Total Cost</b></span></td>
                                                <td className="text-end"><span className="table-body-txt">{priceDetails?.final_price_before_vat ? parseFloat(priceDetails?.final_price_before_vat).toFixed(2) : parseFloat(totalAmount).toFixed(2)} {currency}</span></td>
                                            </tr>

                                            <tr className="bb-1">
                                                <td><span className="table-body-txt"> Vat ({priceDetails?.tax_vat}%)</span></td>
                                                <td className="text-end"><span className="table-body-txt">{vatAmount} {currency}</span></td>
                                            </tr>
                                            <tr className="bb-1">
                                                <td><span className="table-body-txt"><b>Total Pay Amount</b></span></td>
                                                <td className="text-end"><span className="table-body-txt">{parseFloat(payAmount).toFixed(2)}  {currency}</span></td>
                                            </tr>

                                        </tbody>
                                    </table>
                                </div>
                            }


                            {
                                priceDetails?.addon?.length <= 1 && <>
                                    <tr className="bb-1">
                                        <td colSpan={2}>
                                            <div className="subscription_planlist">
                                                <b className="text-xl "><Icon name="form" /> Features</b>
                                                <ul className="mt-3">
                                                    {priceDetails?.feature.map((_featureItem: any, _featureIndex: number) => (
                                                        <li key={`features${_featureIndex}`}>{_featureItem.description}</li>
                                                    ))}
                                                </ul>
                                            </div>
                                        </td>
                                    </tr>
                                </>
                            }



                        </tbody>
                    </table>
                </div>

                <div className="payment-right-box">
                    <div className="  mt-4">
                        <div className="accordion payment-method" id="accordionExample">
                            <h4>Choose payment method</h4>
                            {
                                priceDetails?.payment_methods?.map((paymentMethod: any, pMethodIndex: number) => {
                                    switch (paymentMethod.payment_key) {
                                        case 'stripe':
                                            return <React.Fragment key={`paymentMethod${pMethodIndex}`}>
                                                <div className="accordion-item">
                                                    <h2 className="accordion-header" id="headingOne">
                                                        <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">

                                                            <div className="radio-wrap">
                                                                <label className="container-radio">{paymentMethod?.title}
                                                                    <input type="radio" defaultChecked={pMethodIndex == 0 && true} name="radio" wfd-id="id8" />
                                                                    <span className="checkmark"></span>
                                                                </label>
                                                            </div>
                                                            <img src="../../images/img/strip.png" alt="" />
                                                        </button>
                                                    </h2>
                                                    <div id="collapseOne" className={`accordion-collapse collapse ${pMethodIndex == 0 && ' show'} `} aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                                                        <div className="accordion-body">
                                                            <table>
                                                                <tbody>
                                                                    <tr className="bb-1">
                                                                        <td>
                                                                            <div className="mb-3 float-input light-float">
                                                                                <label className="form-label">Coupon Code  </label>
                                                                                <input type="coupon_code" className="form-control apply_coupon_input" placeholder="ZLO3aYxA"
                                                                                    onChange={(e: any) => { setSouponCode(e.target.value); setSouponCodeSubmit(false) }} />
                                                                            </div>
                                                                        </td>
                                                                        <td className="text-end">
                                                                            <button type="button" className="apply_coupon_btn" disabled={couponCodeSubmit}
                                                                                onClick={applyCouponCodeHandler}>{couponCodeSubmit ? 'Applyed' : 'Apply Coupon'}</button></td>
                                                                    </tr>
                                                                    {
                                                                        couponDiscount > 0 && <tr className="bb-1">
                                                                            <td><span className="table-body-txt"><b>Coupon Code Discount</b></span>
                                                                                {/* <h5>For coupon code</h5> */}
                                                                            </td>
                                                                            <td className="text-end"><span className="table-body-txt">{ couponDiscount } {currency}</span></td>
                                                                        </tr>
                                                                    }
                                                                </tbody>
                                                            </table>


                                                            <Link to={replaceUrlParams(URLS.ACCOUNT.PAYMENT.PAY, { proposalId: proposalId })}>
                                                                <button type="button" className="master-orng-btn mt-4 w-100">Pay {parseFloat(payAmount).toFixed(2)} {currency}</button>
                                                            </Link>
                                                            {/* <em className="text-xs">Powered by <img src="../../images/img/strip.png" alt="" /></em> */}
                                                        </div>
                                                    </div>
                                                </div>
                                            </React.Fragment>
                                        case 'paypal':
                                            return <React.Fragment key={`paymentMethod${pMethodIndex}`}>
                                                <div className="accordion-item">
                                                    <h2 className="accordion-header" id="headingTwo">
                                                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                                            <div className="radio-wrap">
                                                                <label className="container-radio">{paymentMethod?.title}
                                                                    <input type="radio" defaultChecked={pMethodIndex == 0 && true} name="radio" wfd-id="id8" />
                                                                    <span className="checkmark"></span>
                                                                </label>
                                                            </div>
                                                            <img src="../../images/img/paypal.png" alt="" />
                                                        </button>
                                                    </h2>
                                                    <div id="collapseTwo" className={`accordion-collapse collapse ${pMethodIndex == 0 && ' show'} `} aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                                                        <div className="accordion-body">
                                                            <PayPalButton amount={payAmount} proposalId={proposalId} _currency={currency} discountAmount={discountAmount} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </React.Fragment>
                                        default:
                                            <>
                                                <p className="text-red-500 text-xl">No payment mode activated!</p>
                                            </>
                                    }

                                })
                            }

                            {
                                priceDetails?.payment_methods?.length == 0 && <h3 className="text-red-500 m-5">No payment mode activated!</h3>
                            }


                        </div>


                    </div>



                    <div className="summery-logo">
                        <Link to={URLS.HOME}> <img className="nav-logo" src={LOGO_URL} alt={APP_NAME} /></Link>
                    </div>
                </div>
            </div>
        </>
    )
}

export default PaymentDetails